import Loading from "@/components/Loading.vue"
import { Donuz } from "@/donuz-js/Donuz";
import carousel from 'vue-owl-carousel'
// @ is an alias to /src
export default {
  name: "prize",
  components: {
    carousel,
    Loading
  },
  data() {
    return {
      quantity: 1,
      prize: {},
      loading: true,
      client: {}
    };
  },
  async created() {
    let response = await Donuz.prizes.getInfoReward(this.$route.params.id, null, null, this.ESTABELECIMENTO.id);
    if (response.status == 200) {
      this.prize = response.premios[0];
    }
    if (sessionStorage.getItem(btoa("cliente")) != null) {
      this.client = JSON.parse(atob(sessionStorage.getItem(btoa("cliente"))));
    }
    this.loading = false
  },
  methods: {
    submit: async function () {

      if (Object.keys(this.client).length == 0) {
        this.$router.push('/' + this.$route.params.slug + '/login');
        return;
      }

      this.$swal.fire({
        title: 'Atenção!',
        text: "Tem certeza que deseja resgatar esse prêmio?",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.value) {

          let result = await Donuz.redeemption.redeemRewards(
            sessionStorage.getItem(btoa("tokenCliente")),
            { quantidade: this.quantity, id_premio: this.$route.params.id }, this.ESTABELECIMENTO.id
          );
          if (result.status == 200) {
            M.toast({ html:"Premio resgatado com Sucesso!!!", classes: "green" });
            let voucher = result.voucher
            result = Donuz.balance.getCustomerBalance(sessionStorage.getItem(btoa("tokenCliente")), this.ESTABELECIMENTO.id)
            if (result.status == 200) {
              this.client.saldo = result.saldo
              sessionStorage.setItem(btoa("cliente"), btoa(JSON.stringify(this.client)))
            }
            location.href = '/' + this.$route.params.slug + '/voucher/' + voucher
          } else {
            M.toast({ html: result.mensagem, classes: "red" });
          }
        }
      })
    }
  }
};
